// Lista de țări (în limba română). România este prima ca să fie ușor de selectat.
const tari = [
  "România",
  "Republica Moldova",
  "Afganistan",
  "Africa de Sud",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Arabia Saudită",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaidjan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgia",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia și Herțegovina",
  "Botswana",
  "Brazilia",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodgia",
  "Camerun",
  "Canada",
  "Capul Verde",
  "Cehia",
  "Chile",
  "China",
  "Cipru",
  "Columbia",
  "Comore",
  "Congo",
  "Coreea de Nord",
  "Coreea de Sud",
  "Costa Rica",
  "Coasta de Fildeș",
  "Croația",
  "Cuba",
  "Danemarca",
  "Djibouti",
  "Dominica",
  "Ecuador",
  "Egipt",
  "Elveția",
  "Emiratele Arabe Unite",
  "Ecuatorială (Guineea Ecuatorială)",
  "Eritreea",
  "Estonia",
  "Eswatini",
  "Etiopia",
  "Fiji",
  "Filipine",
  "Finlanda",
  "Franța",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germania",
  "Ghana",
  "Grecia",
  "Grenada",
  "Guatemala",
  "Guineea",
  "Guineea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "India",
  "Indonezia",
  "Irak",
  "Iran",
  "Irlanda",
  "Islanda",
  "Israel",
  "Italia",
  "Jamaica",
  "Japonia",
  "Iordania",
  "Kazahstan",
  "Kenya",
  "Kârgâzstan",
  "Kiribati",
  "Kosovo",
  "Kuweit",
  "Laos",
  "Lesotho",
  "Letonia",
  "Liban",
  "Liberia",
  "Libia",
  "Liechtenstein",
  "Lituania",
  "Luxemburg",
  "Macedonia de Nord",
  "Madagascar",
  "Malaezia",
  "Malawi",
  "Maldive",
  "Mali",
  "Malta",
  "Maroc",
  "Insulele Marshall",
  "Mauritania",
  "Mauritius",
  "Mexic",
  "Micronezia",
  "Monaco",
  "Mongolia",
  "Muntenegru",
  "Mozambic",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Norvegia",
  "Noua Zeelandă",
  "Oman",
  "Olanda",
  "Pakistan",
  "Palau",
  "Palestina",
  "Panama",
  "Papua Noua Guinee",
  "Paraguay",
  "Peru",
  "Polonia",
  "Portugalia",
  "Qatar",
  "Regatul Unit",
  "Republica Centrafricană",
  "Republica Democrată Congo",
  "Republica Dominicană",
  "Ruanda",
  "Rusia",
  "Saint Kitts și Nevis",
  "Saint Lucia",
  "Saint Vincent și Grenadinele",
  "Samoa",
  "San Marino",
  "Sao Tome și Principe",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Siria",
  "Slovacia",
  "Slovenia",
  "Somalia",
  "Spania",
  "Sri Lanka",
  "Statele Unite ale Americii",
  "Sudan",
  "Sudanul de Sud",
  "Suedia",
  "Surinam",
  "Tadjikistan",
  "Tanzania",
  "Thailanda",
  "Timorul de Est",
  "Togo",
  "Tonga",
  "Trinidad și Tobago",
  "Tunisia",
  "Turcia",
  "Turkmenistan",
  "Tuvalu",
  "Ucraina",
  "Uganda",
  "Ungaria",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export default tari;
